<template>
    <div class="h-100 d-flex flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_DelegationTemplate")}}</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="border-top p-4 flex-1 d-flex flex-column overflow-auto">
            <v-layout wrap>
                <div class="flex-1">
                    <label>{{$t("res_Label_DelegationTemplateText")}}</label>
                    <v-textarea v-model="structureDelegateText" label="" class="light-bg" rows="10"></v-textarea>
                </div>
                <div class="flex-1">
                    <label>{{$t("res_Label_AvailableKeywords")}}</label>
                    <v-textarea label="" disabled v-model="available_keywords" class="light-bg" rows="10"></v-textarea>
                </div>
            </v-layout>
            <div class="actions d-flex">
                <v-btn color="danger" @click="deleteStructureDelegateText" dense><v-icon dark>mdi-delete-empty</v-icon>{{ $t("res_ButtonText_Delete") }}</v-btn>
                <v-btn color="primary" v-if="delegationId != 0" @click="updateStructureDelegate" dense>{{ $t("res_ButtonText_Update")}}</v-btn>
                <v-btn color="primary" v-else-if="delegationId == 0" @click="postStructureDelegate" dense>{{ $t("res_ButtonText_Save")}}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants'

    export default {
        name: 'TemplateDelegate',
        data() {
            return {
                structureDelegateText: '',
                delegationId: 0,
                available_keywords: 'Signer Name\r\n\r\nSigner Job Title\r\n\r\nDelegate Name\r\n\r\nDelegate Job Title\r\n\r\nDelegate Text'
            };
        },
        props: 
        {
            structure_id: Number,
        },
        watch: 
        {
            structure_id: function (newVal, oldVal) 
            {
                if (newVal != oldVal) 
                {
                    this.fetchStructureDelegate()
                }
            }
        },
        methods:
        {
            fetchStructureDelegate() 
            {
                axios.get(constants.baseApiUrl + 'StructureUser/GetStructureDelegateText?structureId=' + this.structure_id)
                    .then(res => 
                    {
                        if (res.data != null && res.data != "") 
                        {
                            this.delegationId = res.data[0].id;
                            this.structureDelegateText = res.data[0].text
                        }
                    })
                    .catch(err => console.warn(err))
            },
            postStructureDelegate() 
            {
                axios.post(constants.baseApiUrl + 'StructureUser/AddStructureDelegate', { StructureId: this.structure_id, Text: this.structureDelegateText })
                    .then(res => 
                    {
                        window.showAlert(this.$t("res_Msgs_DelegationTemplateAdded"), "success")
                        this.fetchStructureDelegate()
                    })
                    .catch(err => console.warn(err))
            },
            updateStructureDelegate: function () 
            {
                let requestObj = { Id: this.delegationId, StructureId: this.structure_id, Text: this.structureDelegateText }

                axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureDelegate', requestObj)
                    .then(res => 
                    {
                        if (res.data != null && res.data != "") 
                        {
                            window.showAlert(this.$t("res_Msgs_DelegationTemplateUpdated"), "success")
                            this.fetchStructureDelegate()
                        }
                    })
                    .catch(err => console.warn(err))
            },
            deleteStructureDelegateText() 
            {
                var body = { StructureId: this.structure_id, Text: this.structureDelegateText }

                if (this.structureDelegateText != '' || this.structureDelegateText != 'undefined') 
                {
                    axios.get(constants.baseApiUrl + 'StructureUser/DeleteStructureDelegateText?structureId=' + this.structure_id)
                        .then(res => 
                        {
                            if (res.data == true) 
                            {
                                this.structureDelegateText = ''
                                window.showAlert(this.$t("res_Msgs_DelegationTemplateDeleted"), "success")
                                this.delegationId = 0
                            }
                            else 
                            {
                                window.showAlert(this.$t("res_Msgs_NoDelegationTemplate"), "warning");
                            }
                        })
                        .catch(err => console.warn(err))
                }
                else 
                {
                    window.showAlert(this.$t("res_Msgs_NoDelegationTemplate"));
                }
            },
        },
        mounted() 
        {
            this.delegationId = 0
            this.fetchStructureDelegate()
        },
    }
</script>